import { StageData } from '../../game/StageLoader';

export const stage02: StageData = {
  id: 'stage_02',
  name: 'ステージ2: 海上迎撃',
  nameEn: 'Ocean Intercept',
  description: '海上の敵戦闘機と艦艇を殲滅せよ',
  terrain: 'ocean',
  totalEnemies: 8,
  enemies: [
    // 敵戦闘機
    { type: 'fighter', pos: [ 2000,  600, -2500], ai: 'patrol' },
    { type: 'fighter', pos: [-1500,  500, -2000], ai: 'patrol' },
    { type: 'fighter', pos: [ 3000,  800,  1000], ai: 'patrol' },
    { type: 'fighter', pos: [-2000,  700,  2500], ai: 'aggressive' },
    { type: 'fighter', pos: [  500,  450, -3000], ai: 'patrol' },
    { type: 'fighter', pos: [-3000,  600,  -500], ai: 'aggressive' },
    // 艦艇
    { type: 'vessel',  pos: [ 1500,    0,  3000] },
    { type: 'vessel',  pos: [-2500,    0, -1500] },
  ],
};
